import React, { useEffect, useState } from 'react'
import Sidebar from './(components)/sidebar'
import Content from './(components)/content'
import useNav from '../../../../hooks/useNav'
import { useSearchParams } from 'react-router-dom'
import { useLingui } from '@lingui/react/macro'

const InterventionStart = () => {
    const { t } = useLingui()
    const { nav, setNav } = useNav()
    const [searchParams] = useSearchParams()

    const type = searchParams.get('type')

    const [active_tab, setactive_tab] = useState('customer');

    useEffect(()=>{
      setNav({...nav, title:t`Rapportage: callid ${searchParams.get('callid')} ${type ? ` | ${type}` : ''}`})
    }, [])

  return (
    <div className='flex'>
        <Sidebar active_tab={active_tab} setactive_tab={(v)=>{setactive_tab(v)}}/>
        <Content active_tab={active_tab}/>
    </div>
  )
}

export default InterventionStart